import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColumnsShowService {
  columnsShow: any = {}
  tableShow: any = {}
  getObject(columns:any):any{
    let object: any = {}
    columns.forEach((e:any)=>{
      object[e] = true 
    })
    return object
  }
  constructor() { }
}
